import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndicator: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTextIndicator"><Path d="M3.5 5.5H8.5M8.5 5.5H13.5M8.5 5.5V18.5M16.5 3.5H18.5M18.5 3.5H20.5M18.5 3.5V20.5M18.5 20.5H16.5M18.5 20.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTextIndicator;
